import { createContext } from "react";

export const LoaderContext = createContext<boolean>(false);

export const LoaderProvider = LoaderContext.Provider;
export const LoaderConsumer = LoaderContext.Consumer;
